import React from "react";
import Header from "./Header";
import SideBar from "./SideBar";

const index = () => {
  return (
    <>
      <Header />
      <SideBar />
    </>
  );
};

export default index;
